<template>
  <div>
    <span class="label">{{ front_label }}</span>
    <label class="switch" @click="handleSwitchClick">
      <input type="checkbox" v-bind:checked="isActive" v-on:change="toggleSwitch">
      <span class="slider round" @click.stop></span>
    </label>
    <span class="label">{{ back_label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    front_label: {
      type: String,
      default: ''
    },
    back_label: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleSwitch() {
      this.$emit('update:isActive', !this.isActive);
    },
    handleSwitchClick(event) {
      event.stopPropagation();
      this.$emit('click', this.isActive);
    }
  }
};
</script>

<style>
/* Style CSS dla okrągłego przełącznika z etykietą */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 20px;
}

.round {
  border-radius: 20px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

.label {
  margin-left: 5px;
  margin-right: 5px;
  font-size: 14px;
  color: #333;
}
</style>
